<template>
    <section>
        <header-view v-if="elligible"></header-view>
        <div v-bind:class="{wrapper: elligible}">
            <div class="container-fluid">
                <router-view></router-view>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import Header from "@/components/layouts/Header";

    export default {
        name: "MainLayout",
        components: {
            "header-view": Header
        },
        data() {
            return {};
        },
        computed: mapState([
            'profile'
        ]),
        methods: {
            elligible() {
                return this.profile.isAdmin || this.profile.isEmployee;
            }
        }
    };
</script>

<style scoped>
    @media (min-width: 992px){
        .wrapper{
            margin-left: 270px;
        }
    }
    .wrapper .container-fluid{
        padding: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/layouts/Main.vue